import React, { useEffect, useRef } from 'react';
import { Button, Tooltip } from 'antd';
import { BoldOutlined, ItalicOutlined, UnderlineOutlined, LinkOutlined } from '@ant-design/icons';
import { emailDocument } from './mailboxModel';
import './editor.css';

export default function MailEditor({ text, html, disabled, onChange, label = 'Message' }) {
  const editor = useRef(null);
  const lastValue = useRef(null);
  useEffect(() => {
    const value = html || text;
    if (lastValue.current === value || !editor.current) return;
    // A contentEditable assignment destroys the browser selection. Draft state can
    // also arrive from another SRM tab, so never replace the DOM while this editor
    // owns the caret. onBlur publishes the focused editor's value back to the draft.
    if (editor.current.contains(document.activeElement)) return;
    lastValue.current = value;
    if (html) editor.current.innerHTML = new DOMParser().parseFromString(emailDocument(html, true), 'text/html').body.innerHTML;
    else editor.current.textContent = text;
  }, [html, text]);
  const changed = () => { lastValue.current = editor.current.innerHTML; onChange({ text_body: editor.current.innerText || editor.current.textContent || '', html_body: editor.current.innerHTML }); };
  const insert = (tag, href) => {
    const selection = window.getSelection();
    if (!selection?.rangeCount || !editor.current.contains(selection.anchorNode) || !editor.current.contains(selection.focusNode)) return;
    const range = selection.getRangeAt(0);
    if (range.collapsed) return;
    const node = document.createElement(tag);
    if (href) node.setAttribute('href', href);
    node.appendChild(range.extractContents()); range.insertNode(node); selection.removeAllRanges();
    changed();
  };
  return <div className="mail-editor"><div className="mail-format-toolbar" role="toolbar" aria-label="Text formatting">
    {[['Bold', BoldOutlined, 'strong'], ['Italic', ItalicOutlined, 'em'], ['Underline', UnderlineOutlined, 'u'], ['Link', LinkOutlined, 'a']].map(([label, Icon, tag]) => <Tooltip key={tag} title={label}><Button type="text" aria-label={label} icon={<Icon />} size="small" disabled={disabled} onMouseDown={event => event.preventDefault()} onClick={() => {
      if (tag !== 'a') insert(tag);
      else { const url = window.prompt('Link URL (https://…)'); if (url && /^https:\/\//i.test(url)) insert('a', url); }
    }} /></Tooltip>)}
    <small className="mail-muted">Select text to format</small></div>
    <div ref={editor} role="textbox" aria-label={label} aria-multiline="true" aria-disabled={disabled} contentEditable={!disabled} suppressContentEditableWarning data-placeholder={label === 'Message' ? 'Write your message...' : 'Write your signature...'} className="mail-rich-input" onInput={changed} onBlur={changed} onPaste={event => { event.preventDefault(); const selection = window.getSelection(); if (!selection?.rangeCount) return; const range = selection.getRangeAt(0); if (!editor.current.contains(range.commonAncestorContainer)) return; range.deleteContents(); const node = document.createTextNode(event.clipboardData.getData('text/plain')); range.insertNode(node); range.setStartAfter(node); range.collapse(true); changed(); }} />
  </div>;
}
